export const BOT_ID='user_gytf_bot';
export const BOT_NAME='GYTF Bot';
